import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_DEFAULT_OG_IMAGE, canonicalUrl } from "../../config";

interface DocumentHeadProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  ogType?: string;
}

/**
 * Sets per-route document head tags (title, meta description, canonical,
 * Open Graph, Twitter Card) via react-helmet-async.
 *
 * Usage: <DocumentHead title="..." description="..." path="/templates" />
 */
export function DocumentHead({
  title,
  description,
  path,
  ogImage,
  ogType = "website",
}: DocumentHeadProps) {
  const url = canonicalUrl(path);
  const image = ogImage || SITE_DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
